var map = {
	"./arms.jpg": "47a5",
	"./christ.jpg": "5f4b",
	"./conception.jpg": "5b44",
	"./curtains.jpg": "1f79",
	"./mother.jpg": "d489",
	"./saturnina.jpg": "803e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9322";